export default {
  strict: true,
  namespaced: true,
  state: {
    lastUserID: '',
    list: []
  },
  mutations: {
    setCardData (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/cards/index.js